import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleTipuriProgramActiveComponent } from './module-tipuri-program-active.component';
import { AddModuleTipuriProgramActiveComponent } from './add-module-tipuri-program-active/add-module-tipuri-program-active.component';
import { EditModuleTipuriProgramActiveComponent } from './edit-module-tipuri-program-active/edit-module-tipuri-program-active.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';



@NgModule({
    declarations: [
        ModuleTipuriProgramActiveComponent,
        AddModuleTipuriProgramActiveComponent,
        EditModuleTipuriProgramActiveComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        MaterialModule
    ],
    exports: [ModuleTipuriProgramActiveComponent],
})
export class ModuleTipuriProgramActiveModule { }
